import React from 'react'
import styles from './InsertImageModal.scss'
import { ModalOverlay } from 'common/styleguide/ModalOverlay'
import { ImageUpload } from 'common/styleguide/ImageUpload'
import { CircleSpinner } from 'common/spinners'
import { CTA } from 'common/styleguide/CTA'
import { Icon } from 'common/Icon'
import { RadioGroup } from 'common/styleguide/RadioGroup'
import { OrderedMap } from 'immutable'
import { errorMessage } from 'lib/styleguide/base.scss'

export const INSERT_IMAGE_MODAL = 'INSERT_IMAGE_MODAL'
const EMPTY_URL_ERROR = 'EMPTY_URL_ERROR '
const NO_HTTPS_ERROR = 'NO_HTTPS_ERROR '
const ERROR_MESSAGES = {
  [EMPTY_URL_ERROR]: 'Please provide a URL',
  [NO_HTTPS_ERROR]: 'URL must start with http:// or https://'
}

const imageTypes = OrderedMap({
  static: 'Static Image',
  dynamic: 'Dynamic Image',
  link: 'Link to Image'
})

export class InsertImageModal extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      imageType: props.imageType,
      imageUrl: props.imageUrl,
      error: null
    }
  }

  onClickSave = (e) => {
    e.preventDefault()
    const { saveImageTypeAndUrl, onRequestClose } = this.props
    const { imageType, imageUrl } = this.state

    if (imageType === 'link' && imageUrl.trim() === '') {
      this.setState({ error: EMPTY_URL_ERROR })
    } else if (imageType === 'link' && !(imageUrl.startsWith('https://') || imageUrl.startsWith('http://'))) {
      this.setState({ error: NO_HTTPS_ERROR })
    } else {
      let nextImageUrl
      if (imageType !== 'link') {
        nextImageUrl = ''
      } else {
        nextImageUrl = imageUrl
      }

      saveImageTypeAndUrl({ imageType, imageUrl: nextImageUrl })
      onRequestClose()
    }
  }

  onImageTypeChange = (imageType) => {
    this.setState({ imageType })
  }

  onImageUrlChange = (e) => {
    this.setState({ imageUrl: e.target.value })
  }

  onRequestClose = () => {
    this.props.maybeRemoveSelf() // handles removing block if no image
    this.props.onRequestClose() // close the modal
  }

  render () {
    const { savePending, image, onDrop } = this.props
    const { imageType, imageUrl, error } = this.state

    return (
      <ModalOverlay
        onRequestClose={this.onRequestClose}
        maxWidth='400px'
        title='Insert Image'>
        <ImageUpload
          onDrop={onDrop}
          hintTop={`Drop an image here`}>
          {savePending && <span style={{ marginRight: '10px' }}><CircleSpinner size={16} /></span>}
          {image && !savePending && <img className={styles.imgPreview} src={image} />}
          {!image && !savePending && <Icon i='ios-images-outline' size={60} className={styles.emptyIcon} />}
        </ImageUpload>
        {image && !savePending && <RadioGroup
          options={imageTypes}
          selected={imageType}
          onChange={(e) => this.onImageTypeChange(e)} />}
        {imageType === 'link' && <div className={styles.imageUrl}>
          <label htmlFor='linkUrl'>Add URL</label>
          <input
            id='linkUrl'
            type='text'
            placeholder='https://ridewithgps.com'
            value={imageUrl}
            onChange={(e) => this.onImageUrlChange(e)} />
        </div>}
        {error && <div className={errorMessage}>{ERROR_MESSAGES[error]}</div>}
        {image && <CTA margins={false} disabled={savePending} onClick={this.onClickSave}>Save</CTA> }
        <CTA link margins={false} onClick={this.onRequestClose}>Cancel</CTA>
      </ModalOverlay>
    )
  }
}
